import { Select, SelectProps } from 'antd'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { currentUserSortedCompaniesSelector } from '../../../redux/session/currentUser/selectors'

interface CurrentUserCompaniesSelectProps extends Omit<SelectProps, 'options'> {
  // Companies shown but not selectable, e.g. ones already picked elsewhere.
  disabledIds?: string[]
}

const CurrentUserCompaniesSelect = ({ disabledIds, ...props }: CurrentUserCompaniesSelectProps) => {
  const companies = useSelector(currentUserSortedCompaniesSelector)

  const options = useMemo(
    () =>
      companies.map(company => ({
        value: company.id,
        label: company.name,
        disabled: disabledIds?.includes(company.id)
      })),
    [companies, disabledIds]
  )

  return <Select showSearch={{ optionFilterProp: 'label' }} options={options} {...props} />
}

export default CurrentUserCompaniesSelect
